// extracted by mini-css-extract-plugin
export default {"container":"EmailHtml_container__qHLXD","emailThreadHtmlToggleButton":"EmailHtml_emailThreadHtmlToggleButton__yB7a4"};